// extracted by mini-css-extract-plugin
module.exports = {"main":"Putuj_main__3yoHj","itemsFirstRow":"Putuj_itemsFirstRow__2g6y_","itemsSecondRow":"Putuj_itemsSecondRow__Nar9r"};